//import logos
import cd_logo from '@/assets/img/logos/contestdream.png'
import gamify_logo from '@/assets/img/logos/gamify.svg'
import lv_logo from '@/assets/img/logos/loyaltyvenue.svg'
import mca_logo from '@/assets/img/logos/mcaudience.svg'
import swee_logo from '@/assets/img/logos/swee.svg'
import fg_logo from '@/assets/img/logos/feelgrid.svg'
import aquest_logo from '@/assets/img/logos/aquest.png'

import i18n from '@/providers/i18n'

const lipsum = '';

//CONTEST DREAM
export const contestdream = {
  url: {name: 'contestdream'},
  logo: cd_logo,
  name: 'apps.contestdream.title',
  description: 'apps.contestdream.description',
  setuptime: lipsum,
};

//GAMIFY
export const gamify = {
  url: {name: 'gamify'},
  logo: gamify_logo,
  name: 'apps.gamify.title',
  description: 'apps.gamify.description',
  setuptime: lipsum,
};

//LOYALTY VENUE
export const loyaltyvenue = {
  url: {name: 'loyaltyvenue'},
  logo: lv_logo,
  name: 'apps.loyaltyvenue.title',
  description: 'apps.loyaltyvenue.description',
  setuptime: lipsum,
};

//SWEE
export const swee = {
  url: {name: 'swee'},
  logo: swee_logo,
  name: 'apps.swee.title',
  description: 'apps.swee.description',
  setuptime: lipsum,
};

//MCAUDIENCE
export const mcaudience = {
  url: {name: 'mcaudience'},
  logo: mca_logo,
  name: 'apps.mcaudience.title',
  description: 'apps.mcaudience.description',
  setuptime: lipsum,
};

//FEEL GRID
export const feelgrid = {
  url: {name: 'feelgrid'},
  logo: fg_logo,
  name: 'apps.feelgrid.title',
  description: 'apps.feelgrid.description',
  setuptime: lipsum,
};

//aQuest
export const aquest = {
  url: {name: 'aquest'},
  logo: aquest_logo,
  name: 'apps.aquest.title',
  description: 'apps.aquest.description',
  setuptime: lipsum,
};

// export const bounty = {
//   url: {name: 'bounty'},
//   logo: aquest_logo,
//   name: 'Bounty',
//   description: 'Bounty Description',
//   setuptime: lipsum,
// };

// const apps = {
//   contestdream,
//   gamify,
//   loyaltyvenue,
//   swee,
//   mcaudience,
//   feelgrid,
//   aquest,
//   bounty
// };

const apps = {
  contestdream,
  gamify,
  loyaltyvenue,
  swee,
  mcaudience,
  feelgrid,
  aquest
};

export default apps;



// WEBPACK FOOTER //
// ./src/sections/general/apps_list.js